<script lang="ts">
  import { promoCodeValue, userSignedIn, userData } from "../store";
  import { trackButtonClick } from "../utils";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  let overlayText = "Please sign in!";
  let promoCodeMessage = "";
  const redeemPromoCode = process.env.REDEEM_PROMO_CODE;
  // const redeemPromoCode = "http://localhost:3000/redeemPromoCode";

  async function handleClick() {
    if (!$userSignedIn) {
      return;
    }
    const promoButton = document.getElementById("promoButton");
    promoButton.innerHTML = "";

    const loadingText = document.createElement("div");
    loadingText.setAttribute("class", "loading-text");
    loadingText.innerText = "Loading...";
    promoButton.appendChild(loadingText);
    trackButtonClick("PromoCodeButton", 1);
    PromoCode();
  }
  async function PromoCode() {
    const promoCodeAsync = async () => {
      try {
        const promoCodeTextArea = document.getElementById("promocode-textarea");
        $promoCodeValue = promoCodeTextArea.value;

        try {
            const response = await fetch(redeemPromoCode, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: $promoCodeValue,
              user: $userData.id,
            }),
          });

          const responseData = await response.json();
          if (response.ok) {
            document.getElementById("promoCodeMessage").style.color = "green";
            promoCodeMessage = "Success, promo code redeemed!";
          }
          else{
            document.getElementById("promoCodeMessage").style.color = "red";
            promoCodeMessage = responseData.message;
          }
          dispatch("success", responseData);
          document.getElementById("promoButton").innerHTML = "Check Promo Code";
          document.getElementById("promoCodeMessage").innerHTML = promoCodeMessage;

          setTimeout(() => {
            document.getElementById("promocode-textarea").value = "";
            document.getElementById("promoButton").innerHTML = "Check Promo Code";
            document.getElementById("promoCodeMessage").innerHTML = "";
          }, 3000);
        } catch (error) {
          console.error(error);
          document.getElementById("promocode-textarea").value = "";
          document.getElementById("promoButton").innerHTML = "Check Promo Code";
          document.getElementById("promoCodeMessage").innerHTML = promoCodeMessage;
        }
        // Reset button to original state
      } catch (error) {
        console.error(error);
        document.getElementById("promocode-textarea").value = "";
        document.getElementById("promoButton").innerHTML = "Check Promo Code";
        document.getElementById("promoCodeMessage").innerHTML = "";
      }
    };
    setTimeout(promoCodeAsync, 250);
  }
  $: userSignedIn.subscribe((value) => {
    if (value) {
      if ($promoCodeValue.length == 0) {
        overlayText = "Enter Promo Code";
        return;
      } else {
        overlayText = "";
      }
    } else {
      if ($userData.premium || $userData.admin) {
        overlayText = "";
      } else {
        overlayText = "Please sign in!";
      }
    }
  });
</script>

<div class="button-container">
  <button
    id="promoButton"
    class="button promoButton active-button"
    on:click={handleClick}
    class:grey-overlay={!$userSignedIn || $promoCodeValue.length == 0}
  >
    Check Promo Code
  </button>
  <div class="overlay-text">{overlayText}</div>
</div>
